import store from '../store'
const Qs = require('qs')

function extractFilenameFromResponseHeader(xhr) {
  const contentDisposition = xhr.getResponseHeader('Content-Disposition')
  // eslint-disable-next-line
  const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  const result = patt.exec(contentDisposition)
  let filename = ''

  if (result) {
    filename = result.length > 0 ? result[1] : ''
  }
  // eslint-disable-next-line
  return decodeURIComponent(filename.trim().replace(new RegExp('"', 'g'), ''))
}

function getBlob({ url, callback, methods, data, errCallback }) {
  /* eslint-disable no-undef */
  const xhr = new XMLHttpRequest()
  data &&
    Object.keys(data).forEach((key) => {
      if (!data[key]) {
        data[key] = null
      }
    })
  if (methods.toLocaleUpperCase() === 'GET') {
    if (data) {
      url = `${url}&${Qs.stringify(data, { skipNulls: true })}`
    }
    xhr.open(methods, url)
  } else {
    xhr.open(methods, url)
  }

  xhr.setRequestHeader('Authorization', store.state.token)
  if (methods.toLocaleUpperCase() === 'POST') {
    xhr.setRequestHeader('Content-Type', 'application/json')
  }

  xhr.responseType = 'blob'
  xhr.onload = () => {
    callback(xhr.response, extractFilenameFromResponseHeader(xhr))
  }
  xhr.onerror = (e) => {
    errCallback(e)
  }
  console.log(data)
  if (typeof data === 'object') {
    xhr.send(JSON.stringify(data))
  }
  xhr.send(data)
}

function exportExcel({ url, methods = 'GET', data = null }) {
  return new Promise((resolve, reject) => {
    try {
      getBlob({
        url,
        methods,
        data,
        errCallback(err) {
          reject(err)
        },
        callback(blob, filename) {
          if (blob.type === 'application/json') {
            // 返回数据是json不是文件，解析后resolve
            const reader = new FileReader()
            reader.onload = (e) => {
              resolve(e.target.result)
            }
            reader.onerror = () => {
              reject(reader.error)
            }
            reader.readAsText(blob)
          } else {
            var suffix = filename.split('.').reverse()[0]
            console.log(blob, suffix)
            const type = {
              xls: 'application/vnd.ms-excel',
              xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              doc: 'application/msword',
              docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            }[suffix]
            /* eslint-disable no-undef */
            var file = new Blob([blob], { type })
            var url = window.URL.createObjectURL(file)
            console.log(url, 'url')

            var a = document.createElement('a')
            a.href = url
            a.download = filename
            a.click()
            console.log(a)
            window.URL.revokeObjectURL(url)
            resolve()
          }
        }
      })
    } catch (e) {
      resolve(e)
    }
  })
}

export default exportExcel
export { exportExcel }
